import { useFormContext } from 'react-hook-form'

import { useClientePorCpfProposta } from '@/features/clientes/hooks/use-cliente-por-cpf-proposta'
import { BaseRepresentanteLegalForm } from '@/features/proposta/components/ui'
import { useDadosRepresentanteLegal } from '@/features/proposta/hooks/use-dados-representante-legal'
import type { TCompradoresCadastrados } from '@/features/proposta/interfaces/proposta.type'
import type { CompradorPessoaJuridicaSchemaInput } from '@/features/proposta/schemas/compradores/comprador-pj.schema'
import type { TNacionalidade, TProfissao } from '@/shared/interfaces/cliente.types'

type TDadosComprador = {
  onBack: () => void
  onNext: () => void
  compradores: TCompradoresCadastrados
  nacionalidades: TNacionalidade[]
  profissoes: TProfissao[]
}

export const DadosRepresentanteLegal = ({
  onNext,
  onBack,
  compradores,
  nacionalidades,
  profissoes,
}: TDadosComprador) => {
  const {
    formState: { errors },
    watch,
    control,
  } = useFormContext<CompradorPessoaJuridicaSchemaInput>()

  const cpf = watch('responsavel.dados.cpf')
  const buscouCpf = !!watch('responsavel.dados.buscouCpf')
  const cpfRaw = cpf?.replaceAll(/\D/g, '')
  const cpfError = errors?.responsavel?.dados?.cpf
  const isEditing = watch('mode') === 'edit'

  const { refetch, isFetching } = useClientePorCpfProposta(String(cpfRaw), false)
  const { handlers } = useDadosRepresentanteLegal({
    onNext,
    compradores,
    refetch,
    nacionalidadePrincipalId: nacionalidades[0]?.id ?? '',
  })

  return (
    <BaseRepresentanteLegalForm
      onBack={onBack}
      onNext={onNext}
      compradores={compradores}
      nacionalidades={nacionalidades}
      profissoes={profissoes}
      control={control}
      fields={{
        cpf: 'responsavel.dados.cpf',
        nome: 'responsavel.dados.nome',
        nacionalidadeId: 'responsavel.dados.nacionalidadeId',
        profissaoId: 'responsavel.dados.profissaoId',
      }}
      isEditing={isEditing}
      cpf={cpf}
      buscouCpf={buscouCpf}
      cpfError={cpfError}
      isFetching={isFetching}
      handlers={handlers}
    />
  )
}
